export default __webpack_public_path__ + "static/media/privacy.aa45641e.pdf";